import { useEffect, useState } from "react";
import React from "react";
import { useApiClient } from "../../service/API";

export default function UsersLeaveCountList() {
    const apiClient = useApiClient();
    const [data, setData] = useState([]);

    const getList = async () => {
        const response = await apiClient.get("users/balance-leave-list");
        if (response.status === 200) {
            setData(response.data);
        }
    };

    useEffect(() => {
        getList();
    }, []);

    return (
        <div>
            <table className="table table-bordered">
                <thead className="table-secondary">
                    <tr>
                        <th>Email</th>
                        <th>Annual Leave</th>
                        <th>Medical Leave</th>
                        <th>Hospital Leave</th>
                        <th>Unpaid Leave Applied</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((user) => (
                        <tr key={user.id}>
                            <td>{user.email}</td>
                            <td>{user.annual_leave}</td>
                            <td>{user.medical_leave}</td>
                            <td>{user.hospital_leave}</td>
                            <td>{user.unpaid_leave ?? 0}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
